// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".pic_title[data-v-ee0fd1f4] {\n  width: 100%;\n  font-size: 20px;\n  color: #333;\n  font-weight: bolder;\n}\n.pic_list[data-v-ee0fd1f4] {\n  width: 100%;\n  display: flex;\n  flex-wrap: wrap;\n}\n.pic_list .img[data-v-ee0fd1f4] {\n  width: 200px;\n  height: 100px;\n  margin: 10px;\n}\n", ""]);
// Exports
module.exports = exports;
